import styled from 'easyguide'

/*eslint-disable */
export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`
